import jsonp from "jsonp";
import axios, { AxiosResponse } from "axios";
import * as utils from "@/utils";
import type { ApiResponse } from "./types";

const objToAjaxParams = (data: Record<string, any>): string => {
  let txtArr: string[] = [];
  for (let key in data) {
    txtArr.push(`${key}=${data[key]}`);
  }
  txtArr.push("callback");
  return txtArr.join("&");
};

const addToken = (data?: Record<string, any>): Record<string, any> => {
  return Object.assign(data || {});
};

export const getJSON = <T = any>(
  url: string,
  data: Record<string, any> = {}
): Promise<T> => {
  return new Promise((resolve) => {
    jsonp(
      url,
      {
        param: objToAjaxParams(
          addToken({
            ...data,
            cid: utils.getUrlParams("cid"),
            scid: utils.getUrlParams("scid"),
          })
        ),
        prefix: "jsonpCallback",
      },
      (_err: any, res: T) => {
        resolve(res);
      }
    );
  });
};

export const get = <T = any>(
  url: string,
  data?: Record<string, any>
): Promise<T> => {
  return new Promise((resolve) => {
    axios
      .get(url, {
        params: addToken(data || {}),
        timeout: 10000,
        withCredentials: true,
      })
      .then((res: AxiosResponse<T>) => {
        resolve(res.data);
      })
      .catch((res: any) => {
        resolve(res.data);
      });
  });
};

export const post = <T = any>(
  url: string,
  data?: Record<string, any> | FormData,
  responseType: "json" | "blob" | "text" = "json"
): Promise<T> => {
  return new Promise((resolve) => {
    // 如果是 FormData，直接使用，不进行 addToken 处理
    const requestData =
      data instanceof FormData ? data : addToken(data as Record<string, any>);

    axios({
      method: "post",
      url,
      data: requestData,
      responseType,
      timeout: 10000,
      withCredentials: true,
    })
      .then((res: AxiosResponse<T>) => {
        resolve(res.data);
      })
      .catch((res: any) => {
        resolve(res.data || {});
      });
  });
};
